import {ApprovalState} from "../../../home/memo/model/ApprovalState";

export class ApprovableFamilyDayRequestWithRecipientId {

  id:                     number;
  employeeCode:           string;
  refDate:                Date;
  scheduleId:             number;
  approvalState =         ApprovalState.APPROVED;
  requesterNote:          string;
  dayIsPaid:              boolean;
  requesterFullName:      string;
//  schedules =             new Array<EmployeHoraire>();
  approverNote:           string;


  recipientId: string;

  multipleDays = false;
  fromDate: Date;
  toDate: Date;

  _createSpecialElement(propertyName: string, data: any) {
   if ('approvalState' === propertyName) {
     this.approvalState = ApprovalState.retrieveFromCode(data);
     return true;
   }

   return false;
  }


}
